import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=8c0c0dcc&scoped=true&"
import script from "./Me.vue?vue&type=script&lang=js&"
export * from "./Me.vue?vue&type=script&lang=js&"
import style0 from "./Me.vue?vue&type=style&index=0&id=8c0c0dcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0c0dcc",
  null
  
)

export default component.exports